module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAaCAYAAABLlle3AAAARklEQVRIS2O0snf+z0BnwDhqKS1DnJGWhuMye9RSmob6aPDSNnhHSyRahu/AFPi09NFoMThaItE0fQ1M8I4Wg7SM1AEpBgGRPxTfbk04cAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/com/black_nav_icon.png
// module id = aoH5
// module chunks = 30